import { Controller } from "@hotwired/stimulus";
import { clearInputValue, dateRangeLabel, dispatchFilterUpdatedEvent } from "../../datatables/datatable_filters";
import { toggleClass } from "../../utils/misc";

export default class extends Controller {
  static targets = ["startDate", "endDate", "periodInput", "errorMessage"];
  static outlets = ["datatables--selected-filter"];

  connect() {
    if (this.hasDatatablesSelectedFilterOutlet) {
      this.datatablesSelectedFilterOutlet.displayContent(this._translatedValue());
    }
  }

  rangeFilled() {
    [...this.periodInputTargets].forEach((input) => clearInputValue(input));
  }

  periodSelected() {
    [this.startDateTarget, this.endDateTarget].forEach((input) => clearInputValue(input));
  }

  filterChanged() {
    const isPeriodSelected = this.periodInputTargets.find((target) => target.checked);
    const isRangeFilled = !!this.startDateTarget.value || !!this.endDateTarget.value;

    const isFilterValid = isPeriodSelected || isRangeFilled;
    toggleClass(this.errorMessageTarget, "hidden", !isFilterValid);

    if (isFilterValid) {
      this.datatablesSelectedFilterOutlet.displayContent(this._translatedValue());
      this._filterUpdated();
    }
  }

  _filterUpdated() {
    const { filterName } = this.element.dataset;
    dispatchFilterUpdatedEvent({ name: filterName });
  }

  _translatedValue() {
    const startDate = this.startDateTarget.value;
    const endDate = this.endDateTarget.value;

    let value = dateRangeLabel(startDate, endDate);
    const selectedPeriodInput = this.periodInputTargets.find((input) => input.checked);
    if (selectedPeriodInput) {
      value = selectedPeriodInput.dataset.translatedValue;
    }
    return value;
  }
}
